<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qwZiZM/images/e9781439634974_cover.jpg?1684514926739" alt="This image is the cover for the book Morgan County, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Morgan County, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>Based solely on vintage postcards, this important new book is a unique addition to the small number of works devoted to the history of Morgan County. Captured here in more than 220 commercially produced and personal real-photo postcards is a chronicle of the past 100 years in Martinsville (the county seat), Mooresville, Morgantown, Waverly, and other communities that have been imprinted on the local landscape. This visual record showcases the people, neighborhoods, schools, businesses, recreation sites, and events that shaped Morgan County�including the famous mineral water sanitariums, landmark buildings and bridges, favorite fishing holes and resorts, and disasters such as the 1913 flood of the White River.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanne Raetz Stuttgen, Curtis Tomak
      </h2>
      
      <p class="authorDescription body article">Joanne Raetz Stuttgen is a folklorist and cultural resources specialist active in local history research and historic preservation. Curtis Tomak, an archaeologist with the State of Indiana, is an avid collector of vintage postcards and local memorabilia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61021754